<div class="page-title animatedBackground">
    <div class="container">
        <h3>Media Service</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Media Service</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="project-details-area ptb-100">
    <div class="container">
        <div class="project-img">
            <img src="assets/img/media_service.png" alt="photo">
        </div>
        <div class="project-details">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <h3>AM Media & Sports: Let’s Create Magic Together!</h3>
                    <p>At AM Media & Sports, we believe in the power of stories. The kind that inspire, connect, and
                        celebrate everyday heroes. Powered by passionate talent, smart tech, and a commitment to
                        accessibility, we’re here to create content that resonates with everyone — because great stories
                        deserve great audiences.</p>
                    <p>But we don’t just stop at creating. We train, mentor, and open doors for the next generation of
                        media professionals. From fresh talent to seasoned creators, brands, and broadcasters — if you
                        have a story, we’ll help you tell it, beautifully.</p>
                    <div class="project-details-overview">
                        <div class="mt-3 project-details-desc">
                            <h3>Building Skills & Delivering Excellence</h3>
                            <p>Before we unleash our full range of services for production houses, TV channels, OTT
                                platforms, and businesses, we’re investing in what matters most — people.</p>
                            <p>Our hands-on training programs are designed for anyone with a spark for media, especially
                                persons with disabilities, women, and young talent from rural communities. We’re here to
                                level the playing field and give everyone a shot at shining in the media world.</p>
                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i>What you’ll learn</h4>
                                <p>
                                    🎙️ Voice-overs | 🎞️ Audio Descriptions | ✍️Scriptwriting | 🎬 Editing | 📺
                                    Production Know-How And so much more — practical, industry-ready skills to help you
                                    thrive.
                                </p>
                            </div>
                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i>What We Do Best: Your One-Stop Media Hub</h4>
                                <p>🎥 <b>Content Creation & Production</b></p>
                                <ul class="features">
                                    <li>
                                        Corporate films, educational videos, documentaries, sports coverage — you name
                                        it, we create it.
                                    </li>
                                    <li>
                                        Stories that celebrate achievements and give voice to diverse, often unheard
                                        communities.
                                    </li>
                                    <li>
                                        Custom content partnerships for brands and organizations that want to stand
                                        out and connect meaningfully.
                                    </li>
                                </ul>
                            </div>
                            <div class="features-text">
                                <p>✂️ <b>Post-Production & Polish</b></p>
                                <ul class="features">
                                    <li>
                                        Seamless editing, localization, subtitling, and quality control to get your
                                        content broadcast-ready.
                                    </li>
                                    <li>
                                        Expertly crafted audio descriptions and accessibility features for truly
                                        inclusive media.
                                    </li>
                                    <li>
                                        Fast, reliable, and high-quality — so you can focus on telling your story while
                                        we handle the fine-tuning.
                                    </li>
                                </ul>
                            </div>
                            <div class="features-text">
                                <p>🌍 <b>Making Media Accessible for All</b></p>
                                <ul class="features">
                                    <li>
                                        Audio Descriptions for films, shows, web content, and live sports.
                                    </li>
                                    <li>
                                        Transcriptions — accurate, human-reviewed, and multi-language.
                                    </li>
                                    <li>
                                        Indian Sign Language (ISL) Interpretation for events, broadcasts, and digital
                                        media.
                                    </li>
                                    <li>
                                        Accessibility Consulting to help you meet standards, legal requirements, and
                                        audience expectations.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="mt-5 project-details-desc">
                            <h3>Why Choose AM Media & Sports?</h3>
                            <p>
                                ✅ Open to All: We actively welcome and uplift communities that often get left behind.
                            </p>
                            <p>
                                ✅ Media & Sports Experts: A unique mix of storytellers, production specialists, sports
                                managers, and accessibility champions.
                            </p>
                            <p>
                                ✅ Tech-Savvy & Future-Ready: Leveraging AI and cutting-edge tools to make content
                                smarter, faster, and more inclusive.
                            </p>
                            <p>
                                ✅ Impact-Driven: More than a business — a movement to empower, inspire, and build a
                                media world where everyone belongs.
                            </p>

                            <div class="features-text">
                                <h4><i class="icofont-check-alt"></i>Ready to Join the Movement?</h4>
                                <p>
                                    If you’re a storyteller, broadcaster, production house, sports body, or brand that
                                    wants to make meaningful, inclusive content — let’s collaborate.
                                    Together, we’ll create work that celebrates champions from every walk of life and
                                    shape a media space where creativity, inclusion, and quality lead the way.
                                </p>
                                <ul class="features">
                                    <li>
                                        Enquire About Our Services
                                    </li>
                                    <li>
                                        Register for Training
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>